<script>
import Alerts from "@/components/Alerts.vue";

export default {
    name: "CloseRequests",
    components: {Alerts},
    data() {
        return {
            erps: []
        }
    },
    methods: {
        loadUnBudgetedErps() {
            this.$http.get('/requests/unbudgeted').then(response => {
                this.erps = response.data.data
                this.wait = true

                if (this.erps.length > 0) {
                    this.$refs.modalBtn.click();
                }

            }).catch(error => {
                this.showError(error)
            }).then(() => {
                this.wait = false
            })
        },
        goToBudgeting(code) {
            this.$refs.closeBtn.click();
            this.$router.push(`/requests/budgeting/${code}`)
        }
    },
    mounted() {
        this.loadUnBudgetedErps()
    }
}
</script>

<template>
    <div>
        <button type="button"
                class="d-none" ref="modalBtn"
                data-toggle="modal"
                data-target="#myModal"
                data-backdrop="static">Open Modal
        </button>

        <div class="modal fade" id="myModal" role="dialog">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <!-- Modal body -->
                    <div class="modal-body p-4">
                        <h4 class="modal-title font-weight-bold">Complete Budgeting</h4>
                        <p class="text-muted">
                            The following ERPs do not have their budgeting completed.<br>
                            Please complete the budgeting for you to be able to create new ERPs
                        </p>
                        <p class="font-weight-bold">
                            Total Unclose ERPs: {{ erps.length }}
                        </p>

                        <alerts :_loading="wait" :_error="error" :_success="success"></alerts>

                        <div v-for="i in erps" :key="i.code" class="p-3 mb-3 border rounded-lg rounded">

                            <span class="text-muted float-right">
                                &nbsp; {{ day(i.created_at).format('MMM, DD YYYY') }}
                            </span>
                            <h5 class="font-weight-bold">{{ i.user.name }}</h5>

                            <div>
                                ERP Code <b>{{ i.code }}</b> -
                                $<b class="font text-success">{{ currency(i.amount) }}</b>
                            </div>
                            <p class="small">{{ i.title }}</p>
                            <p class="text-muted">
                                Disbursed On: {{ day(i.disbursed_at).format('MMMM, DD YYYY') }} ({{ Math.round(i.days_past) }} days
                                ago)
                            </p>

                            <span :class="'status ' + i.status">{{ i.status }}</span> &nbsp;

                            <span v-if="!i.budgeted_at" class="text-danger border-danger small rounded-lg p-1 border">Not Budgeted</span>

                            <button @click="goToBudgeting(i.code)" class="btn btn-dark float-right rounded-lg">
                                Complete Budgeting
                            </button>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <div class="modal-footer border-0">
                        <button type="button" ref="closeBtn" class="btn btn-outline-danger rounded-lg" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>